var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "24px",
    viewBox: "0 0 22 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2E2659A9-0276-4B90-B5B2-D97EED9EA845") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Patients",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iPhone-6/7/8-\\u2013-39-Copy-56",
    transform: "translate(-176.000000, -587.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "refresh",
    transform: "translate(176.000000, 587.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9849995,23.6819179 C16.2920824,23.3112081 20.3155918,18.7332294 20.3155918,13.4133892 C20.3153485,13.0172644 19.9949276,12.6962711 19.5997527,12.6962712 L17.1807102,12.6962712 C16.7589998,12.6984459 16.4176724,13.0405938 16.4155029,13.4633179 C16.4155029,16.7294524 13.9717764,19.5749483 10.7134743,19.8223827 C6.98617419,20.0698171 3.87597675,16.950376 4.14573877,13.19114 C4.36613258,9.92500561 7.206568,7.47540478 10.4895542,7.47540478 L12.1460341,7.47540478 L12.1460341,9.75180151 C12.1460341,10.617822 13.1087142,11.1374343 13.8245533,10.6673089 L20.3164734,6.43618018 C20.9829443,6.01554166 20.9829443,5.02580395 20.3164734,4.60516542 L13.8236717,0.373153024 C13.1078326,-0.096530541 12.1460341,0.423081756 12.1460341,1.28910225 L12.1460341,3.56549898 L10.5151199,3.56549898 C5.20891851,3.56549898 0.641477199,7.59868015 0.272097174,12.9185203 C-0.172216746,19.0301507 4.88802512,24.1025564 10.9832363,23.6819179 L10.9849995,23.6819179 Z",
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.40304ba1c873f1fa9472f176b3ec404a.svg";
export { ForwardRef as ReactComponent };